import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToDownload: {
        id: 'twia.common.documentupload.Unable to Download',
        defaultMessage: 'Unable To Download Documents, Please Try Again Later',
    },
    activityTitle: {
        id: 'twia.Activity.documentupload.Activity Title',
        defaultMessage: 'Documents for this Activity',
    },
    residentialTWIA: {
        id: 'twia.Residential.documentupload.Info Message',
        defaultMessage: 'Please select the Document Type and click the "+ Upload Documents" button to upload documents. After you upload a document, please update the description and click the Save button. Contact TWIA if you need to delete a document.',
    },
    residentialTFPA: {
        id: 'tfpa.Residential.documentupload.Info Title',
        defaultMessage: 'Please select the Document Type and click the "+ Upload Documents" button to upload documents. After you upload a document, please update the description and click the Save button. Contact TFPA if you need to delete a document.',
    },
    commercialTWIA: {
        id: 'twia.Comercial.documentupload.Info Title',
        defaultMessage: 'Please select the Document Type and click the "+ Upload Documents" button to upload documents. After you upload a document, please update the description, select the Building, and click the Save button. Contact TWIA if you need to delete a document.',
    },
    uploadSizeLimitMessage: {
        id: 'ent.common.documentupload.Upload Limit Message',
        defineMessages: 'Do not upload files containing illegal content or copyrighted information without the permission of the copyright owner. File names must not exceed 60 characters (including the file type extension). Files must not exceed 20MB.',
    },
    uploadDocument: {
        id: 'ent.common.documentupload.Upload Documents',
        defaultMessage: 'Upload Documents',
    },
    documentSave: {
        id: 'ent.common.documentupload.Document Save',
        defaultMessage: 'SAVE',
    },
    dateUploaded: {
        id: 'ent.common.documentupload.Date Uploaded',
        defaultMessage: 'DATE UPLOADED',
    },
    documentBuilding: {
        id: 'ent.common.documentupload.Document Building',
        defaultMessage: 'BUILDING',
    },
    documentType: {
        id: 'ent.common.documentupload.Document Type',
        defaultMessage: 'DOCUMENT TYPE',
    },
    documentDescription: {
        id: 'ent.common.documentupload.Document Description',
        defaultMessage: 'DESCRIPTION',
    },
    documentName: {
        id: 'ent.common.documentupload.Document Name',
        defaultMessage: 'NAME',
    },
    defaultDocumentTypeMessage: {
        id: 'ent.common.documentupload.Default Document Type Message',
        defaultMessage: '-- Please Select Document Type --',
    },
    searchDocuments: {
        id: 'ent.common.documentupload.Search Documents',
        defaultMessage: 'Search Documents',
    },
    supportedFileFormat: {
        id: 'ent.common.documentupload.Please upload a supported file format',
        defaultMessage: 'Please upload a supported file format: .avi, .bmp, .doc, .docm, .docx, .dot, .gif, .jpeg, .jpg, .mov, .mpg, .pdf, .png, .ppt, .pptx, .rtf, .tif, .tiff, .txt, .wav, .wmv, .xls, .xlsx.',
    }
    ,
    maxLengthMessage: {
        "id": "ent.common.documentupload.Document names cannot exceed 60 characters, including the extension. Please shorten the document name and try again.",
        "defaultMessage": "Document names cannot exceed 60 characters, including the extension. Please shorten the document name and try again."
    },
    maxFileSizeKBMessage: {
        "id": "ent.common.documentupload.Documents larger than 30MB are not allowed. Please try a smaller file.",
        "defaultMessage": "Documents larger than 30MB are not allowed. Please try a smaller file."
    },
    otherDocument: {
        id: 'ent.common.additionalinformation.documentupload.Other document',
        defaultMessage: 'Other document',
    },
    badFileTypeTitle: {
        id: 'ent.common.additionalinformation.documentupload.Bad File Type Title',
        defaultMessage: 'Bad File Format',
    },
    unableRetrieveDocuments: {
        id: 'ent.common.additionalinformation.documentupload.Failed to retrieve buildings',
        defaultMessage: 'The document(s) could not be retrieved. Please try again later.',
    },
    uploadFailedMessage: {
        id: 'ent.common.additionalinformation.documentupload.The document could not be uploaded, please try again later. For assistance, you may contact TWIA at (800) 788-8247.',
        defaultMessage: 'The document could not be uploaded, please try again later. For assistance, you may contact TWIA at (800) 788-8247.',
    },
    noBuildingSelected: {
        id: 'ent.common.additionalinformation.documentupload.Please select a Building for the document you are uploading.',
        defaultMessage: 'Please select a Building for the document you are uploading.',
    },
});